import React, { useEffect, useRef, useState } from 'react';
import SpotTable from '../styled/SpotTable';
import Grid from '@mui/material/Grid2';
import { Typography } from '@mui/material';
import SpotButton from '../styled/SpotButton';
import { useTheme } from '@emotion/react';
import AddIcon from '@mui/icons-material/Add';
import SpotFilterButton from '../styled/SpotFilterButton';

export default function DeliveryChallanMgmt() {
  const theme = useTheme();
  const [selectedFilter, setSelectedFilter] = useState('');

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
  };

  const filterOptions = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
  ];

  const columns = [
    { key: 'name', label: 'S.No' },
    { key: 'calories', label: 'Calories',  },
    { key: 'fat', label: 'Fat (g)',},
    { key: 'carbs', label: 'Carbs (g)', },
    { key: 'protein', label: 'Protein (g)' },
  ];

  const rows = [
    { name: 'Frozen yoghurt', calories: 159, fat: 6.0, carbs: 24, protein: 4.0 },
    { name: 'Ice cream sandwich', calories: 237, fat: 9.0, carbs: 37, protein: 4.3 },
    { name: 'Eclair', calories: 262, fat: 16.0, carbs: 24, protein: 6.0 },
    { name: 'Cupcake', calories: 305, fat: 3.7, carbs: 67, protein: 4.3 },
    { name: 'Gingerbread', calories: 356, fat: 16.0, carbs: 49, protein: 3.9 },
  ];

  return (
    <Grid container justifyContent="center" sx={{width:"100%"}} spacing={2}>
      <Grid item container size={11} justifyContent="space-between" spacing={8}>
        <Grid item>
          <Typography fontSize="32px" fontWeight="600px" pl={2}>Material Management</Typography>
        </Grid>
        <Grid item container>
          <SpotButton startIcon={<AddIcon/>} sx={{color:theme.palette.common.white, bgcolor:theme.palette.secondary.main, textTransform:"none", height:"40px"}}>Enter Details</SpotButton>
          <SpotFilterButton
            label="Filter By"
            options={filterOptions}
            value={selectedFilter}
            onChange={handleFilterChange}
            placeholder="Select Filter"
          />
        </Grid>
      </Grid>
      <Grid item size={11} >
        <SpotTable columns={columns} rows={rows}/>
      </Grid>
    </Grid>
  );
}
